import { useCustomerFormStoreAction } from '../stores/customer-form.store'

export const useClearCustomerStore = () => {
  const {
    setCustomerSelected,
    setCustomerFormJson,
    setCustomerFormTable,
    setCustomerFormCities,
    setOperationToFillValues,
    setIsFillValuesAfterRequestCities,
  } = useCustomerFormStoreAction

  const clearAllStore = () => {
    setCustomerFormJson(undefined)
    setCustomerSelected(undefined)
    setCustomerFormTable(undefined)
    setCustomerFormCities(undefined)
    setIsFillValuesAfterRequestCities(false)
    setOperationToFillValues('customerForm')
  }

  return {
    action: {
      clearAllStore,
    },
  }
}
